import { flow } from 'fp-ts/function';
import { constant, get, map, mapKeys, set, toLower, update } from 'lodash/fp';

import { createReducer } from '@mews/framework';

import {
    FETCH_PAYMENT_CONFIGURATION_FAILED,
    FETCH_PAYMENT_CONFIGURATION_STARTED,
    FETCH_PAYMENT_CONFIGURATION_SUCCEEDED,
} from './actionTypes';
import {
    FetchPaymentConfigurationFailedPayload,
    FetchPaymentConfigurationStartedPayload,
    FetchPaymentConfigurationSucceededPayload,
} from './payloadTypes';
import { PaymentConfiguration } from './types';

const INITIAL_STATE = {};

export const paymentConfigurations = createReducer(INITIAL_STATE, {
    [FETCH_PAYMENT_CONFIGURATION_STARTED]: (
        state: PaymentConfiguration,
        { enterpriseId }: FetchPaymentConfigurationStartedPayload
    ) => update(enterpriseId, constant({ isFetching: true, hasFailed: false }), state),

    [FETCH_PAYMENT_CONFIGURATION_SUCCEEDED]: (
        state: PaymentConfiguration,
        { paymentGateway, surchargeConfiguration, enterpriseId }: FetchPaymentConfigurationSucceededPayload
    ) =>
        update(
            enterpriseId,
            (configuration) => ({
                ...configuration,
                paymentGateway: paymentGateway ? transformSupportedCreditCardTypesToLowerCase(paymentGateway) : null,
                surchargeConfiguration: {
                    ...surchargeConfiguration,
                    surchargeFees: transformSurchargeKeysToLowercase(surchargeConfiguration),
                },
                isFetching: false,
                hasFailed: false,
            }),
            state
        ),

    [FETCH_PAYMENT_CONFIGURATION_FAILED]: (
        state: PaymentConfiguration,
        { enterpriseId }: FetchPaymentConfigurationFailedPayload
    ) => set(enterpriseId, { isFetching: false, hasFailed: true }, state),
});

const transformSupportedCreditCardTypesToLowerCase = update('supportedCreditCardTypes', map(toLower));

const transformSurchargeKeysToLowercase = flow(get('surchargeFees'), mapKeys(toLower));
